import { Button } from 'primereact/button';
import { useRef } from "react";
import { useReactToPrint } from "react-to-print"
import React from "react";
import { Toolbar } from "primereact/toolbar";
import { Card } from "primereact/card";
import { Panel } from "primereact/panel";
import onzeSolucoes from "../../assets/onze_solucoes_login.png"
import quodImg from "../../assets/quod.png"
import RespostaInsumoPage from "./resposta/RespostaInsumo";
import useMobile from "../../hooks/useMobile";
import './RespostaMobile.css';


export default function ConsultaPage({
  resposta,
  onClose,
  original
}: {
  resposta: any
  onClose: () => void,
  original: boolean
}) {
  const isMobile = useMobile();
  const print = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => print.current,

  })

  const startContent = (
    <React.Fragment>
      <Button label="Imprimir" icon="pi pi-print" style={{ backgroundColor: '#183462' }} onClick={() => { handlePrint() }} />
    </React.Fragment>
  );

  const endContent = (
    <React.Fragment>
      <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
    </React.Fragment>
  );

  const rodapeMensagem = `ATENÇÃO: As informações deste relatório são confidenciais e deverão ser utilizadas exclusivamente para orientação das transações comerciais, responsabilizando-se civil e criminalmente por danos causados a terceiros, quando da utilização em desacordo com a legislação em vigor.`;

  return (<>
    <Toolbar style={{ width: '98%' }} start={startContent} end={endContent} />
    <br></br>
    <br></br>
    <div ref={print} className={`flex flex-column align-items-center print-container ${isMobile ? 'mobile-mode' : ''}`} >
      <style type="text/css" media="print">{`
        @page { size: portrait; margin: 10mm; }
        .label-dados { font-size: 6pt; }
        .print-container { width: 100% !important; }
        .print-container br { display: none !important; }
        .print-container .p-card { margin-bottom: 0.5rem !important; box-shadow: none !important; border: 1px solid #dee2e6 !important; }
        .print-container .p-card-body { padding: 0.5rem !important; }
        .print-header-grid { align-items: center; margin: 0; }
        .print-header-grid .col.p-fluid { padding: 0.5rem !important; }
        .print-header-grid h1, .print-header-grid h5 { margin: 0 !important; }
      `}</style>
      <Card className="print-header-card" style={{ width: '98%', marginBottom: '1rem' }}>
        <div className="grid print-header-grid">
          <div className={isMobile ? 'flex justify-content-center w-full' : 'col p-fluid flex flex-wrap justify-content-center'} style={{ alignItems: 'center' }}>
            <img className={resposta.informativo.hideQuod ? 'quodImage' : ''} src={onzeSolucoes} alt="Onze Soluções" style={{ width: '150px' }}></img>
          </div>
          <div style={{ textAlign: 'center' }} className="col p-fluid flex flex-column justify-content-center align-items-center">
            <h1 style={{ margin: 0 }}>{resposta.informativo.opcoesPai}</h1>
            <h5 style={{ margin: 0 }}>{resposta.informativo.opcoes}</h5>
          </div>
          <div style={{ textAlign: 'center' }} className="col p-fluid flex flex-wrap justify-content-center align-items-center">
            {original && (<img className={resposta.informativo.hideQuod ? 'quodImage' : ''} src={quodImg} alt="Quod" style={{ width: '180px' }}></img>)}
          </div>
        </div>
      </Card>

      {resposta.analiseIA && (
        <Panel header="Análise com IA" style={{ width: '98%', marginBottom: '1rem' }}>
          <div style={{ padding: "8px 0px", width: "100%", textAlign: "justify", lineHeight: "1.4" }}>
            <span dangerouslySetInnerHTML={{ __html: resposta.analiseIA }} />
          </div>
        </Panel>
      )}

      <RespostaInsumoPage resposta={resposta}></RespostaInsumoPage>


      <br></br>
      <Card style={{ width: '98%' }}>
        <p style={{ fontSize: '10px', textAlign: 'center' }}>
          {rodapeMensagem}
        </p>
      </Card>
    </div>
    <br></br>
    <br></br>
    <Toolbar style={{ width: '98%' }} start={startContent} end={endContent} />
    <br></br>
    <br></br>
    <br></br>
    <br></br>
  </>)
}
